<template>
    <div v-if="show" class="modal">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">{{ title }}</h3>
            </div>
            <div class="modal-body">
                <p v-if="!isReleaseNote" class="modal-message">
                    {{ message }}
                </p>
                <QuillEditor
                    v-else
                    :content="editorContent"
                    :readOnly="true"
                    :options="{ modules: { toolbar: false } }"
                    contentType="html"
                    theme="snow"
                />
            </div>
            <div class="modal-footer">
                <AQCheckBox
                    v-if="isReleaseNote"
                    v-model="dontShowAgain"
                    :label="$t('forms.labels.dontShowAgain')"
                    hide-details
                    class="dont-show-checkbox"
                />
                <v-spacer />
                <AQButton variant="flat" color="secondary" @click="closeModal">{{
                    isReleaseNote ? $t('forms.btn.close') : $t('forceUpdate.continue')
                }}</AQButton>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref, computed } from 'vue';
    import { QuillEditor } from '@vueup/vue-quill';
    import '@vueup/vue-quill/dist/vue-quill.snow.css';
    import AQButton from '@/components/shared/forms/inputs/AQButton.vue';
    import AQCheckBox from '@/components/shared/forms/inputs/AQCheckBox.vue';

    interface Props {
        show?: boolean;
        title?: string;
        message?: string;
        isReleaseNote?: boolean;
    }

    const props = withDefaults(defineProps<Props>(), {
        show: false,
        title: '',
        message: 'Default Message',
        isReleaseNote: false,
    });

    const emit = defineEmits<{
        (e: 'close', dontShowAgain: boolean): void;
    }>();

    const dontShowAgain = ref(false);
    const editorContent = computed(() => props.message);

    const closeModal = () => {
        emit('close', dontShowAgain.value);
    };
</script>
